import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})

/*
  This service it's necessary for the gtmService since we need the information of the personal info and
  the applicant info in every trigger of the gtm service.
*/
export class AppStateService {
  personalInfo = { email: "", previousStudentID: "" };
  applicantInfo = { appId: "" };
  constructor() {}
}
